import { render } from "react-dom";
import App from "./app";

const root = document.getElementById("app");

render(<App />, root);
